var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ClientsTable',{attrs:{"clients":_vm.layout === 'choosePerson' ? _vm.projectClients : _vm.clients,"layout":_vm.layout}})
}
var staticRenderFns = []

export { render, staticRenderFns }